import { render } from "./EventEditIndex.vue?vue&type=template&id=d42a7fe8"
import script from "./EventEditIndex.vue?vue&type=script&lang=js"
export * from "./EventEditIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__